export default __webpack_public_path__ + "static/media/promocionAlarma1Mobile.985f1e74.png";